function createCreateTicketModal(cfg) {
  let creationModal  = createAsideModal({
    el: cfg.el
  });
  let el = creationModal.getEl();
  let availableEventUrl;
  let creatorUserId={};
  let reporterType='guest';
  let ticketProgram=cfg.xProgram||xProgram;
  let adminTypeParametr={};
  let dateSelector = el.find('[name="eventId"]');
  el.find('input[data-mask="phone"]').inputmask("999-999-9999");
  el.find('input[name="files"]').change(function () {
    let html = "";
    if (this.files.length > 0) {
      $.each(this.files, function (k, file) {
        html += file.name + "<br>";
      });
      el.find('span[data-prop="file-values"]').html(html);
    } else {
      resetFileUploadField();
    }
  });

  el.find('form').validator().unbind('submit').submit(function (e) {
    if (e.isDefaultPrevented()) return;


    let url = '/anonymous/tickets';
    let inputEl = el.find('input[name="files"]').get(0);
    let formData = new FormData();
    let data = $(this).serializeObject();
    if(cfg.creator === 'admin')  $.extend( data, {program:$('.create-ticket-modal-for-admin select[name="program"]').val()} );
   else {
     if(typeof ticketProgram !== 'undefined' ) $.extend( data, {program:ticketProgram} );
    }

    if(cfg.creator === 'admin') {
      data.storeNumber = el.find('.input-name-location').data().value;
      data.assigneeId = el.find('.input-name-responsibleAccount').data().value;

      if(data.program==='school-lunch'){
        if(data.eventId)  {
          delete data.eventId;

          let optionData =  dateSelector.find("option:selected").data().fullData;
          if(isOrder(optionData)){
            data.orderId =optionData.id;
          }
          else{
            data.deliveryId = optionData.id;
          }
        }
      }
      if(data.program==='read-with-me'){
        if(data.eventId)  {
          data.enrollmentRefillId = data.eventId;
          delete data.eventId;
        }
      }
      if(data.program==='achievements-awards'){
        if(data.eventId)  {
          data.orderId = data.eventId;
          delete data.eventId;
        }
      }
      if(data.program==='explore-lunar-new-year'){
        if(data.eventId)  {
          data.orderId = data.eventId;
          delete data.eventId;
        }
      }
      if(data.program==='teacher-appreciation-request'){
        if(data.eventId)  {
          data.requestId = data.eventId;
          delete data.eventId;
        }
      }


      if(data.receiverType === 'guest') {
        data.receiverId = el.find('.input-name-guestAccount').data().value;
      } else if(data.receiverType === 'ap') {
        data.receiverId = el.find('.input-name-apAccount').data().value;
      }

      url = "/manage/tickets";
    }
    else if(cfg.creator === 'ap') {
      url = '/ap/tickets';
      if(ticketProgram === "fundraiser"){
      data.storeNumber = el.find('.input-name-location').data().value;

      if(el.find('[name="associatedEventDate"]').val() !== ""){
        if(typeof el.find('.input-name-location').data().value == "undefined" || el.find('.input-name-location').val() ==""){
          el.find('.input-name-location').closest(".form-group").addClass('has-error');
          return;
        }
      }
      }

    }
    else if(cfg.creator=== 'guest-help') {

      if(data.notAssociatedAnyEvent) data.notAssociatedAnyEvent  = !!data.notAssociatedAnyEvent;
      if(data.notAssociatedAnyOrder) data.notAssociatedAnyOrder  = !!data.notAssociatedAnyOrder;
      if(data.notAssociatedAnyRequest) data.notAssociatedAnyRequest  = !!data.notAssociatedAnyRequest;
      if(ticketProgram==='school-lunch'){
      if(data.eventId)  {
        delete data.eventId;

        let optionData =  dateSelector.find("option:selected").data().fullData;
        if(isOrder(optionData)){
          if(!data.notAssociatedAnyOrder)data.orderId =optionData.id;
        }
        else{
          if(!data.notAssociatedAnyOrder)data.deliveryId = optionData.id;
        }
      }
      }
      if(data.program==='read-with-me'){
        if(data.eventId)  {
          data.enrollmentRefillId = data.eventId;
          delete data.eventId;
        }
      }
      if(data.program==='explore-lunar-new-year'){
        if(data.eventId)  {
          data.orderId = data.eventId;
          delete data.eventId;
        }
      }
      if(data.program==='achievements-awards'){
        if(data.eventId)  {
          data.orderId = data.eventId;
          delete data.eventId;
        }
      }
      if(data.program==='teacher-appreciation-request'){
        if(data.eventId)  {
          data.requestId = data.eventId;
          delete data.eventId;
        }
      }

      if(data.notAssociatedAnyOrder === true && data.eventId )  delete data.eventId;
      if(data.notAssociatedAnyEvent === true && data.eventId )  delete data.eventId;
      if(data.notAssociatedAnyEvent === true && data.orderId )  delete data.orderId;
      if(data.notAssociatedAnyRequest === true && data.requestId )  delete data.requestId;

      if (el.find('.input-name-location').length>0) {
        data.storeNumber = el.find('.input-name-location').data().value;
      }
      if(data.email){
        let eventDates='';
        if(!Array.isArray(data.date)){
                eventDates+= 'Event Date: '+data.date+'<br>'+
              'Event hours: '+data.startTime+' to '+data.endTime+'<br>'+
              'Number of Anticipated Attendees: '+data.numberOfGuests+'<br>';
        }
        else{
          eventDates+='<ul>';
          $.each(data.date,function (k) {
            eventDates+= '<li>Event Date: '+data.date[k]+'<br>'+
            'Event hours: '+data.startTime[k]+' to '+data.endTime[k]+'<br>'+
            'Number of Anticipated Attendees: '+data.numberOfGuests[k]+'</li>';
          });
          eventDates+='</ul>';
        }

        data.description+='<br><br><h3><b>Event information:</b></h3>' +
            'Organization: '+data.organizationName+'<br>'+
            'Organization Tax ID: '+data.organizationTaxId+'<br>'+
            'Store: #'+data.storeNumber+'<br>'+
            eventDates+
            '<h3><b>Authorized signer info: </b></h3>'+
            'Name: '+data.name+'<br>'+
            'Position: '+data.position+'<br>'+
            'Email: '+data.email+'<br>'+
            'Reward Number: '+(data.reward||'N/A')+'<br>'+
            'Referral Code: '+(data.referralCode||'N/A')+'<br>'+
            'Phone Number : '+(getMaskedValueFromString(data.phone))+'<br>';

        data.phone = $('.create-ticket-modal-for-geust-help-hawai input[data-mask="phone"]').inputmask('unmaskedvalue');
        data.hawaiiStoreEventMetadata = {
          startTime:Array.isArray(data.startTime)?data.startTime[0]:data.startTime,
          endTime:Array.isArray(data.endTime)?data.endTime[0]:data.endTime,
          numberOfGuests:Array.isArray(data.numberOfGuests)?data.numberOfGuests[0]:data.numberOfGuests,
          date:Array.isArray(data.date)?data.date[0]:data.date,
          allDay:Array.isArray(data.allDay)?data.allDay[0]:data.allDay,
          organizationId:data.organizationId,
          storeId:data.storeId,
        };


        delete data.referralCode;
        delete data.reward;
        delete data.allDay;
        delete data.organizationId;
        delete data.storeId;
        delete data.email;
        delete data.organizationName;
        delete data.organizationTaxId;
        delete data.startTime;
        delete data.endTime;
        delete data.numberOfGuests;
        delete data.name;
        delete data.phone;
        delete data.date;
      }

        url = '/guest/tickets';

    }

  if(cfg.creator != 'guest')
      {
        let reject = false;
        let supportedFormats = ["image/png","image/jpg","image/jpeg","text/csv",'application/vnd.ms-excel','application/pdf','application/msword','text/plain'];
        $.each(inputEl.files, function(k, file){
          if(supportedFormats.includes(file.type)){
            formData.append('files', file);
          }
          else {
            reject = true;
            return false;
          }

        });
        if(reject){
          Modal.show({
            html: "Supported file formats are  .csv, .pdf, .jpg, .png, .txt, .doc, .xls",
            no: "Close",
            withoutYes: true,
            without_no: true,
            onHide:function(){

            }
          });
          return;
        }
      }

    let gRecaptcha='';
    if(cfg.creator == 'guest'){
      gRecaptcha = data.gRecaptcha;
      delete data.gRecaptcha;
    }



    if(cfg.creator == 'guest'){
      let programSelector = el.find('select[name="program"]');
      if(programSelector.length) data.program  = programSelector.val();
      formData = JSON.stringify(data);
    }
    else{
      formData.append('data', JSON.stringify(data));
    }


    request({
        loadingEl: $(".aside-modal .content").addClass('loading-mask'),
        url: url,
        method:"POST",
        processData: false,
        contentType:(cfg.creator == 'guest'?'application/json': false),
        headers:{
          gRecaptcha:gRecaptcha
        },
        data: formData,
        callback:function(r) {
          self.reset();
          self.hide();
          if(cfg.creator && cfg.creator != 'admin'){
            setTimeout(function(){
              Modal.show({
                html: 'Thank you for contacting the Community Programs Team at Panda Express! This is to confirm your ticket has been received and will be addressed by our team in the order it was received. Our response times are typically within 1-3 business days',
                no: 'Close',
                withoutYes: true,
                type: 'success'
              });
            },350);
          }
          if(typeof cfg.onSuccess === "function") cfg.onSuccess();
          cfg.onCreate && cfg.onCreate(r);
        },
      preventDefaultError: true,
      onError: function(errors) {
        if(typeof(grecaptcha) != "undefined"){
          gRecaptchaReset();
        }
        $.each(errors, function(k, error) {
          Validation.displayError(error.field, error.message);
        });
      }
    });
  });

  el.find('select[name="program"]').change(function(){
    if(
        $(this).val()==='learn-with-me' ||
        $(this).val()==='school-lunch' ||
        $(this).val()==='read-with-me' ||
        $(this).val()==='explore-lunar-new-year'
    ){
      el.find('input[value="ap"]').prop({checked:false}).closest('label').hide();
      el.find('input[value="guest"]').prop({checked:true}).trigger('change');
      el.find('input[value="store"]').closest('label').show();
    }
    else if($(this).val()==='virtual-fundraiser'){
      el.find('input[value="ap"]').prop({checked:false}).closest('label').show();
      el.find('input[value="store"]').prop({checked:false}).closest('label').hide();
    }
    else  if($(this).val()==='fundraiser')  {
      el.find('input[value="ap"]').closest('label').show();
      el.find('input[value="store"]').closest('label').show();
    }
    else if($(this).val()==='achievements-awards'){
      el.find('input[value="ap"]').prop({checked:false}).closest('label').hide();
      el.find('input[value="store"]').prop({checked:false}).closest('label').hide();
      el.find('input[value="guest"]').prop({checked:true}).trigger('change');
    }
    else if($(this).val()==='teacher-appreciation-request'){
      el.find('input[value="ap"]').prop({checked:false}).closest('label').hide();
      el.find('input[value="store"]').prop({checked:false}).closest('label').hide();
      el.find('input[value="guest"]').prop({checked:true}).trigger('change');
    }

    if($(this).val()==='school-lunch'){
      $('.label-for-school-lunch').show();
      $('.label-for-other-program').hide();
      $('.label-for-explore-lunar-new-year').hide();
      $('.label-for-read-with-me').hide();
      $('.label-for-paw').hide();
      $('.label-for-tar').hide();
    }
    else if($(this).val()==='read-with-me'){
      $('.label-for-school-lunch').hide();
      $('.label-for-other-program').hide();
      $('.label-for-explore-lunar-new-year').hide();
      $('.label-for-read-with-me').show();
      $('.label-for-paw').hide();
      $('.label-for-tar').hide();
    }
    else if($(this).val()==='explore-lunar-new-year'){
      $('.label-for-school-lunch').hide();
      $('.label-for-other-program').hide();
      $('.label-for-read-with-me').hide();
      $('.label-for-explore-lunar-new-year').show();
      $('.label-for-paw').hide();
      $('.label-for-tar').hide();
    }
    else if($(this).val()==='achievements-awards'){
      $('.label-for-school-lunch').hide();
      $('.label-for-other-program').hide();
      $('.label-for-read-with-me').hide();
      $('.label-for-explore-lunar-new-year').hide();
      $('.label-for-paw').show();
      $('.label-for-tar').hide();
    }
    else if($(this).val()==='teacher-appreciation-request'){
      $('.label-for-school-lunch').hide();
      $('.label-for-other-program').hide();
      $('.label-for-read-with-me').hide();
      $('.label-for-explore-lunar-new-year').hide();
      $('.label-for-paw').hide();
      $('.label-for-tar').show();
    }
    else{
      $('.label-for-school-lunch').hide();
      $('.label-for-read-with-me').hide();
      $('.label-for-explore-lunar-new-year').hide();
      $('.label-for-paw').hide();
      $('.label-for-tar').hide();
      $('.label-for-other-program').show();

    }
  });



  if(cfg.creator === 'admin') {
    el.find('[name="receiverType"]').change(function () {
      dateSelector.prop({disabled:true}).find("option").remove();
      el.find('.input-name-location').val('');
      el.find('.input-name-apAccount').val('');
      el.find('.input-name-guestAccount').val('');
      reporterType=this.value;
      setReporterType(this.value);
    });

    createSuggestor({
      suggester: el.find('#guestAccount-suggestions'),
      input: el.find('.input-name-guestAccount'),
      dataProvider: function(str, loadData) {
        request({
          url: '/users?group=guest&searchText=' + encodeURIComponent(str),
          method: 'GET',
          data: {},
          callback: function (res) {


            loadData(res.data);
          }
        });
      },
      buildItem: function (user) {
        let optionName = user.firstName + ' ' + user.lastName  + ' (' + user.email + ')';

        return $('<div>').attr({'data-id': user.id, 'data-email': user.email}).html(optionName);
      },
      onSelect: function (selection, input) {
        input.val(selection.data().email).data({value: selection.data().id}).trigger('change');
        creatorUserId = {guestId:el.find('.input-name-guestAccount').data().value};


        let group = "";
        if (reporterType == "ap" || cfg.creator == "ap") {
          group = "ap_related";
        }

        if(el.find('form  select[name="program"]').val()==='school-lunch'){
          request({
            loadingEl: $('#create-ticket-modal-for-admin-associatedEventDate').closest('.form-group').addClass('loading-mask'),
            url:'/'+$('.create-ticket-modal-for-admin select[name="program"]').val()+'/orders-deliveries',
            data:$.extend(creatorUserId, {group:group}),
            callback:function(dateInfo){

              dateSelector.find('option').remove();
              if(dateInfo.length) dateSelector.prop({disabled:false});
              else {
                dateSelector.prop({disabled:true});
              }

              $.each(dateInfo,function(k,date){
                if(isOrder(date)){
                  dateSelector.append($('<option>').data({fullData:date}).attr({value:date.id,selected:date.type==dateInfo.type && date.id==dateInfo.id?true:false}).text('Order - '+date.nickname));
                }else {
                  dateSelector.append($('<option>').data({fullData:date}).attr({value:date.id,selected:date.type==dateInfo.type && date.id==dateInfo.id?true:false}).text('Delivery - '+date.date));
                }
              });
              dateSelector.trigger('change');


            }
          });
        }
        else if(el.find('form  select[name="program"]').val()==='read-with-me'){
          request({
            url:'/'+$('.create-ticket-modal-for-admin select[name="program"]').val()+'/enrollments/available-enrollments',
            data:$.extend(creatorUserId, {group:group}),
            callback:function(dateInfo){
              dateSelector.find('option').remove();
              if(dateInfo.length) dateSelector.prop({disabled:false});
              else {
                dateSelector.prop({disabled:true});
              }
              $.each(dateInfo,function(k,date){
                dateSelector.append($('<option>').attr({value:date.enrollmentRefillId}).text(date.nickname));
              });
              dateSelector.trigger('change');
            }
          });
        }
        else if(el.find('form  select[name="program"]').val()==='achievements-awards'){
          request({
            url:'/'+$('.create-ticket-modal-for-admin select[name="program"]').val()+'/orders/available-orders',
            data:$.extend(creatorUserId, {group:group}),
            callback:function(dateInfo){
              dateSelector.find('option').remove();
              if(dateInfo.length) dateSelector.prop({disabled:false});
              else {
                dateSelector.prop({disabled:true});
              }
              $.each(dateInfo,function(k,date){
                dateSelector.append($('<option>').attr({value:date.id}).text(date.nickname));
              });
              dateSelector.trigger('change');
            }
          });
        }
        else if(el.find('form  select[name="program"]').val()==='explore-lunar-new-year'){

          request({
            url:'/'+$('.create-ticket-modal-for-admin select[name="program"]').val()+'/orders/available-orders',
            data:$.extend(creatorUserId, {group:group}),
            callback:function(dateInfo){
              dateSelector.find('option').remove();
              if(dateInfo.length) dateSelector.prop({disabled:false});
              else {
                dateSelector.prop({disabled:true});
              }
              $.each(dateInfo,function(k,date){
                dateSelector.append($('<option>').attr({value:date.id}).text('Event - '+date.date));
              });
              dateSelector.trigger('change');
            }
          });
        }
        else if(el.find('form  select[name="program"]').val()==='teacher-appreciation-request'){
          request({
            url:'/'+$('.create-ticket-modal-for-admin select[name="program"]').val()+'/requests/available-requests',
            data:$.extend(creatorUserId, {group:group}),
            callback:function(dateInfo){
              dateSelector.find('option').remove();
              if(dateInfo.length) dateSelector.prop({disabled:false});
              else {
                dateSelector.prop({disabled:true});
              }
              $.each(dateInfo,function(k,date){
                dateSelector.append($('<option>').attr({value:date.id}).text(date.createDate+' '+date.teacherEmail));
              });
              dateSelector.trigger('change');
            }
          });
        }
        else{
          request({
            url:'/'+$('.create-ticket-modal-for-admin select[name="program"]').val()+'/events/available-events',
            data:$.extend(creatorUserId, {group:group}),
            callback:function(dateInfo){
              dateSelector.find('option').remove();
              if(dateInfo.length) dateSelector.prop({disabled:false});
              else {
                dateSelector.prop({disabled:true});
              }
              $.each(dateInfo,function(k,date){
                dateSelector.append($('<option>').attr({value:date.id}).text(date.date));
              });
              dateSelector.trigger('change');
            }
          });
        }
      }
    });

    createSuggestor({
      suggester: el.find('#apAccount-suggestions'),
      input: el.find('.input-name-apAccount'),
      dataProvider: function(str, loadData) {
        request({
          url: '/users?group=ap&searchText=' + encodeURIComponent(str),
          method: 'GET',
          data: {},
          callback: function (res) {
            loadData(res.data);
          }
        });
      },
      buildItem: function (user) {
        let optionName = user.firstName + ' ' + user.lastName  + ' (' + user.email + ')';

        return $('<div>').attr({'data-id': user.id, 'data-email': user.email}).html(optionName);
      },
      onSelect: function (selection, input) {
        input.val(selection.data().email).data({value: selection.data().id}).trigger('change');
        if(el.find('select[name="program"]').val() === 'virtual-fundraiser'){
          request({
            url:'/virtual-fundraiser/events/available-events?group=ap_related',
            callback:function(dateInfo){

              dateSelector.find('option').remove();
              if(dateInfo.length) {
                dateSelector.prop({disabled:false});
              }
              else {
                dateSelector.prop({disabled:true});
              }
              $.each(dateInfo,function(k,data){
                dateSelector.append($('<option>').attr({value:data.id}).text(data.date));
              });
              dateSelector.trigger('change');
            }
          });
        }
      }
    });

    createSuggestor({
      suggester: el.find('#responsibleAccount-suggestions'),
      input: el.find('.input-name-responsibleAccount'),
      dataProvider: function(str, loadData) {
        request({
          url: '/users?group=admin&searchText=' + encodeURIComponent(str),
          method: 'GET',
          data: {},
          callback: function (res) {
            loadData(res.data);
          }
        });
      },
      buildItem: function (user) {
        let optionName = user.firstName + ' ' + user.lastName  + ' (' + user.email + ')';

        return $('<div>').attr({'data-id': user.id, 'data-email': user.email}).html(optionName);
      },
      onSelect: function (selection, input) {
        input.val(selection.data().email).data({value: selection.data().id}).trigger('change');

      }
    });
  }


  if(cfg.creator === 'admin' || cfg.creator === 'ap' ||  cfg.creator === 'guest-help') {

    if(cfg.creator === 'admin') {
      adminTypeParametr={Type:reporterType};
      availableEventUrl= '/'+$('.create-ticket-modal-for-admin select[name="program"]').val()+'/events/available-events';

    } else if(cfg.creator === 'ap') {
      availableEventUrl = '/'+ticketProgram+'/events/available-events';
    } else if(cfg.creator=== 'guest-help') {
      if(ticketProgram==='read-with-me'){
        availableEventUrl= '/'+ticketProgram+'/enrollments/available-enrollments';
      }
      else{
        availableEventUrl= '/'+ticketProgram+'/events/available-events';
      }
    }





    createSuggestor({
      suggester: el.find('.storeId-suggestions'),
      input: el.find('.input-name-location'),
      url: "/stores?searchText={str}&nearByStoresFeatureEnabled=true",
      buildItem: function (store) {
        let storeInfo = generateStoreName(store);
        el.find('.input-name-location').closest(".form-group").removeClass('has-error');

        return $('<div>').attr({'data-id': store.id,'data-number': store.number, 'data-name': store.name}).html(storeInfo[0]).data({conceptName:storeInfo[1]});
      },
      onSelect: function (selection, input) {
        input.val("#"+selection.data().number+' - '+selection.data().conceptName+' '+selection.data().name).data({value: selection.data().number}).trigger('change');

        let dateSelector = el.find('[name="eventId"]');
        dateSelector.val('');

        let group = "";
        if (reporterType == "ap" || cfg.creator == "ap") {
          group = "ap_related";
        }

        adminTypeParametr={group:group};

        let availableEventParametrs = {storeId:selection.data().id};
        availableEventParametrs = $.extend(availableEventParametrs, adminTypeParametr);



        if(reporterType =='store' || reporterType =='ap') creatorUserId={};


        if(cfg.creator === 'admin') {
          availableEventUrl= '/'+$('.create-ticket-modal-for-admin select[name="program"]').val()+'/events/available-events';
          if($('.create-ticket-modal-for-admin select[name="program"]').val() === 'read-with-me') availableEventUrl= '/'+$('.create-ticket-modal-for-admin select[name="program"]').val()+'/enrollments/available-enrollments';

        }

        if((isCurrentUserAdmin && $('.create-ticket-modal-for-admin select[name="program"]').val() ==='school-lunch')|| (!isCurrentUserAdmin && ticketProgram==='school-lunch')){

          request({
            url:'/school-lunch/orders-deliveries',
            data:$.extend(availableEventParametrs, creatorUserId),
            callback:function(dateInfo){

              dateSelector.find('option').remove();
              if(dateInfo.length) dateSelector.prop({disabled:false});
              else {
                dateSelector.prop({disabled:true});
              }

              $.each(dateInfo,function(k,date){
                if(isOrder(date)){
                  dateSelector.append($('<option>').data({fullData:date}).attr({value:date.id,selected:date.type==dateInfo.type && date.id==dateInfo.id?true:false}).text('Order - '+date.nickname));
                }else {
                  dateSelector.append($('<option>').data({fullData:date}).attr({value:date.id,selected:date.type==dateInfo.type && date.id==dateInfo.id?true:false}).text('Delivery - '+date.date));
                }
              });
              dateSelector.trigger('change');


            }
          });
        }
        else if((isCurrentUserAdmin && $('.create-ticket-modal-for-admin select[name="program"]').val() ==='read-with-me')|| (!isCurrentUserAdmin && ticketProgram==='read-with-me')){
          request({
            url:availableEventUrl,
            data:$.extend(availableEventParametrs, creatorUserId),
            callback:function(dateInfo){
              dateSelector.find('option').remove();
              if(dateInfo.length) {
                dateSelector.prop({disabled:false});
              }
              else {
                dateSelector.prop({disabled:true});
              }
              $.each(dateInfo,function(k,data){
                dateSelector.append($('<option>').attr({value:data.enrollmentRefillId}).text(data.nickname));
              });
              dateSelector.trigger('change');
            }
          });
        }
        else if((isCurrentUserAdmin && $('.create-ticket-modal-for-admin select[name="program"]').val() ==='achievements-awards')|| (!isCurrentUserAdmin && ticketProgram==='achievements-awards')){
          availableEventUrl= '/achievements-awards/orders/available-orders';

          request({
            url:availableEventUrl,
            data:$.extend(availableEventParametrs, creatorUserId),
            callback:function(dateInfo){
              dateSelector.find('option').remove();
              if(dateInfo.length) {
                dateSelector.prop({disabled:false});
              }
              else {
                dateSelector.prop({disabled:true});
              }
              $.each(dateInfo,function(k,data){
                dateSelector.append($('<option>').attr({value:data.id}).text(data.nickname));
              });
              dateSelector.trigger('change');
            }
          });
        }
        else if((isCurrentUserAdmin && $('.create-ticket-modal-for-admin select[name="program"]').val() ==='explore-lunar-new-year')|| (!isCurrentUserAdmin && ticketProgram==='explore-lunar-new-year')){
          availableEventUrl= '/explore-lunar-new-year/orders/available-orders';

          request({
            url:availableEventUrl,
            data:$.extend(availableEventParametrs, creatorUserId),
            callback:function(dateInfo){
              dateSelector.find('option').remove();
              if(dateInfo.length) dateSelector.prop({disabled:false});
              else {
                dateSelector.prop({disabled:true});
              }
              $.each(dateInfo,function(k,date){
                dateSelector.append($('<option>').attr({value:date.id}).text('Event - '+date.date));
              });

            }
          });

        }
        else{
          request({
            url:availableEventUrl,
            data:$.extend(availableEventParametrs, creatorUserId),
            callback:function(dateInfo){
              dateSelector.find('option').remove();
              if(dateInfo.length) {
                dateSelector.prop({disabled:false});

              }
              else {
                dateSelector.prop({disabled:true});


              }
              $.each(dateInfo,function(k,data){
                dateSelector.append($('<option>').attr({value:data.id}).text(data.date));
              });
              dateSelector.trigger('change');
            }
          });
        }




      }
    });
  }

  function setReporterType(type) {
    el.find('.fields-for-guest, .fields-for-ap, .fields-for-store').hide().find('input').removeAttr('required');
    el.find('.fields-for-' + type).show().find('input').attr({ required: 'required' });

    if(el.find('select[name="program"]').val() === 'virtual-fundraiser') {
      el.find('.fields-for-store').hide().find('input').removeAttr('required');
    }

    el.find('form').validator('update');
  }

  function resetFileUploadField() {
    el.find('span[data-prop="file-values"]').text("Upload files");
  }


  el.find('[name="notAssociatedAnyEvent"], [name="notAssociatedAnyOrder"], [name="notAssociatedAnyRequest"]').change(function(){
    let check = $(this).is(':checked');
    $('select[name="eventId"]').prop({required:!check?true:false});
    el.find('.input-name-location').prop({required:!check?true:false});
    if(check){
      $('select[name="eventId"] option').remove();
      el.find('.input-name-location').val('');
    }
    el.find("form").validator('validate');
  });




  let self = {
    reset: function() {
      el.find('form').get(0).reset();
      if(el.find('.input-name-responsibleAccount').length) el.find('.input-name-responsibleAccount').removeData('value');
      if($("#create-ticket-modal-for-admin-associatedEventDate").length) $("#create-ticket-modal-for-admin-associatedEventDate option").remove();
      resetFileUploadField();
    },
    hide: function() {
      if(cfg.outsideDialog)
        el.modal('hide');
      else
      creationModal.hide();
      if(cfg.successMessage) {
        setTimeout(function () {
          Modal.show({
            html: 'The ticket was sent successfully!',
            withoutYes: true,
            no: 'Close',
            type: 'success'
          });
        }, 400);

      }
    },
    show: function (event) {
      if(cfg.outsideDialog)
        el.modal('show');
      else
      creationModal.show();

      if(cfg.creator !== 'ap' && !isCurrentUserAdmin && ticketProgram === 'virtual-fundraiser'){
        if(cfg.creator!== 'guest')
        request({
          url:availableEventUrl,
          callback:function(dateInfo){


            dateSelector.find('option').remove();
            if(dateInfo.length) {
              dateSelector.prop({disabled:false});
            }
            else {
              dateSelector.prop({disabled:true});
            }
            $.each(dateInfo,function(k,data){
              dateSelector.append($('<option>').attr({value:data.id,selected:event && data.date==event.date?true:false}).text(data.date));
            });
            dateSelector.trigger('change');
          }
        });
      }
      if(cfg.creator !== 'ap' && !isCurrentUserAdmin && ticketProgram === 'teacher-appreciation-request'){
        if(cfg.creator!== 'guest')
        request({
          url:'/teacher-appreciation-request/requests/available-requests',
          callback:function(dateInfo){
            dateSelector.find('option').remove();
            if(dateInfo.length) {
              dateSelector.prop({disabled:false});
            }
            else {
              dateSelector.prop({disabled:true});
            }
            $.each(dateInfo,function(k,data){
              dateSelector.append($('<option>').attr({value:data.id,selected:event && data.id==event.id?true:false}).text(data.createDate+' '+data.teacherEmail));
            });
            dateSelector.trigger('change');
          }
        });
      }
      if(!isCurrentUserAdmin && ticketProgram === 'explore-lunar-new-year'){
        if(cfg.creator!== 'guest')
        {
          availableEventUrl= '/explore-lunar-new-year/orders/available-orders';
          request({
            url:availableEventUrl,
            callback:function(dateInfo){
              dateSelector.find('option').remove();
              if(dateInfo.length) dateSelector.prop({disabled:false});
              else {
                dateSelector.prop({disabled:true});
              }
              $.each(dateInfo,function(k,date){
                dateSelector.append($('<option>').attr({value:date.id, selected: date?.id === event?.id}).text('Event - '+date.date));
              });

            }
          });
        }
      }
    },
    setStoreAndDate:function(event){

      let guestInput = el.find('input.input-name-guestAccount');

      if(guestInput.length>0){
        setTimeout(function () {
          guestInput.val(event.guest.email).data({value:event.guest.id});
        },10);
      }
      else  {
       if(event.store) el.find('.input-name-location').val("#"+event.store.number+" - "+event.store.name).data({value:event.store.number});
      }


      if(cfg.creator === 'admin') {
        availableEventUrl= '/'+$('.create-ticket-modal-for-admin select[name="program"]').val()+'/events/available-events';

      }

      if(ticketProgram==='school-lunch'){
        availableEventUrl= '/school-lunch/orders-deliveries';
            request({
              loadingEl:$('#create-ticket-modal-for-admin-associatedEventDate').closest('.form-group').addClass('loading-mask'),
              url:availableEventUrl,
              data:{storeId:event.store.id},
              callback:function(dateInfo){
                dateSelector.find('option').remove();
                if(dateInfo.length) dateSelector.prop({disabled:false});
                else {
                  dateSelector.prop({disabled:true});
                }

                $.each(dateInfo,function(k,date){
                    dateSelector.append($('<option>').data({fullData:date}).attr({value:date.id,selected:date.id==event.id?true:false}).text('Order - '+date.nickname));
                });

              }
            });

      }
      else if(ticketProgram === 'virtual-fundraiser'){
          dateSelector.attr({disabled:false})
              .append($('<option>')
                  .attr({value:event.id,selected:event.date==event.date?true:false}).text(event.date));
      }
      else if(ticketProgram === 'teacher-appreciation-request'){
        if(isCurrentUserAdmin || isCurrentUserSuperAdmin){
          dateSelector.attr({disabled:false})
              .append($('<option>')
                  .attr({value:event.id}).text(event.createDate+' '+event.teacherEmail));
        }
        else{
          setTimeout(function (){
            dateSelector.attr({disabled:false})
                .val(event.id);
          },400);
        }
      }
      else if(ticketProgram === 'read-with-me'){
        availableEventUrl= '/read-with-me/enrollments/available-enrollments';

        request({
          url:availableEventUrl,
          data:{storeId:event.store.id},
          callback:function(dateInfo){
            dateSelector.find('option').remove();
            if(dateInfo.length) dateSelector.prop({disabled:false});
            else {
              dateSelector.prop({disabled:true});
            }
            $.each(dateInfo,function(k,date){
              dateSelector.append($('<option>').attr({value:date.enrollmentRefillId,selected:date.enrollmentRefillId==event.enrollmentRefillId?true:false}).text(date.nickname));
            });

          }
        });

      }
      else if(ticketProgram === 'achievements-awards'){
        availableEventUrl= '/achievements-awards/orders/available-orders',

        request({
          url:availableEventUrl,
          data:{storeId:event.store.id},
          callback:function(dateInfo){
            dateSelector.find('option').remove();
            if(dateInfo.length) dateSelector.prop({disabled:false});
            else {
              dateSelector.prop({disabled:true});
            }
            $.each(dateInfo,function(k,date){
              dateSelector.append($('<option>').attr({value:date.id,selected:date.id==event.id?true:false}).text(date.nickname));
            });

          }
        });

      }
      else if(ticketProgram === 'explore-lunar-new-year'){
        availableEventUrl= '/explore-lunar-new-year/orders/available-orders';

        request({
          url:availableEventUrl,
          data:{'orderId':event.id},
          callback:function(dateInfo){
            dateSelector.find('option').remove();
            if(dateInfo.length) dateSelector.prop({disabled:false});
            else {
              dateSelector.prop({disabled:true});
            }
            $.each(dateInfo,function(k,date){
              dateSelector.append($('<option>').attr({value:date.id, selected: date?.id === event?.id}).text('Event - '+date.date));
            });

          }
        });

      }
      else {
          request({
            url:availableEventUrl,
            data:{storeId:event.store.id},
            callback:function(dateInfo){
              dateSelector.find('option').remove();
              if(dateInfo.length) dateSelector.prop({disabled:false});
              else {
                dateSelector.prop({disabled:true});
              }
              $.each(dateInfo,function(k,date){
                dateSelector.append($('<option>').attr({value:date.id,selected:date.date==event.date?true:false}).text(date.date));
              });

            }
          });
        }


    }
  };

  return self;
}

window.createCreateTicketModal = createCreateTicketModal;